import {css} from 'lit';
import {tablet} from '../../js/services/const';

export const iconsFont = css`
  .icon {
    font-family: 'icons';
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 3.2rem;
    line-height: 100%;
  }

  .button .icon,
  button .icon,
  input .icon {
    font-size: 2rem;
    line-height: 100%;
  }

  /** redesign */
.icon-video:before {
  content: '\\e90c';
}
.icon-quiz:before {
  content: '\\e90d';
}
.icon-slideshow:before {
  content: '\\e90e';
}
.icon-live:before {
  content: '\\e911';
}
.icon-thin-arrow-next:before {
  content: '\\e90f';
}
.icon-thin-arrow-back:before {
  content: '\\e910';
}

.icon-search:before {
  content: '\\e626';
}

.icon-comment:before {
  content: '\\e616';
}

.icon-arrow-left:before {
  content: '\\e600';
}

.icon-arrow-right:before {
  content: '\\e601';
}

.icon-arrow-down:before {
  content: '\\e607';
}

.icon-arrow-next:before {
  content: '\\e623';
}

.icon-arrow-up:before {
  content: '\\e608';
}

.icon-menu:before {
  content: '\\e620';
}

.icon-new:before {
  content: '\\e618';
}

.icon-top:before {
  content: '\\e619';
}

.icon-glass-plus:before {
  content: '\\e627';
}

.icon-glass-minus:before {
  content: '\\e628';
}

.icon-close:before {
  content: '\\e625';
}

.icon-rating-full:before {
  content: '\\e657';
}

.icon-rating-quarter3:before {
  content: '\\e656';
}

.icon-rating-half:before {
  content: '\\e655';
}

.icon-rating-quarter1:before {
  content: '\\e654';
}

.icon-rating-empty:before {
  content: '\\e653';
}

.icon-time:before {
  content: '\\e622';
}

.icon-reload:before {
  content: '\\e904';
}

.icon-bmirechner:before {
  content: '\\e673';
}

.icon-home:before {
  content: '\\e905';
}

.icon-thumbsup:before {
  content: '\\e901';
}

.icon-thumbsdown:before {
  content: '\\e902';
}

.icon-email:before {
  content: '\\e60e';
}

.icon-position:before {
  content: '\\e631';
}

.icon-bullet:before {
  content: '\\e64b';
}

/** Icons Weather */
.icon-wind-N:before {
  content: '\\e636';
}

.icon-wind-NNO:before {
  content: '\\e642';
}

.icon-wind-NO:before {
  content: '\\e637';
}

.icon-wind-ONO:before {
  content: '\\e646';
}

.icon-wind-O:before {
  content: '\\e638';
}

.icon-wind-OSO:before {
  content: '\\e647';
}

.icon-wind-SO:before {
  content: '\\e639';
}

.icon-wind-SSO:before {
  content: '\\e643';
}

.icon-wind-S:before {
  content: '\\e63a';
}

.icon-wind-SSW:before {
  content: '\\e644';
}

.icon-wind-SW:before {
  content: '\\e63b';
}

.icon-wind-WSW:before {
  content: '\\e648';
}

.icon-wind-W:before {
  content: '\\e63c';
}

.icon-wind-WNW:before {
  content: '\\e649';
}

.icon-wind-NW:before {
  content: '\\e632';
}

.icon-wind-NNW:before {
  content: '\\e645';
}

.icon-no-data:before {
  content: '\\e63e';
}

.icon-spin:before {
  -webkit-animation: 1s linear 0s infinite spin;
  -moz-animation: 1s linear 0s infinite spin;
  animation: 1s linear 0s infinite spin;
  color: var(--cp-grey-light-3);
  content: '\\e63f';
  cursor: default;
  display: block;
  font-size: 3.2rem;
  line-height: 32px;
}

// service-tool
.icon-freemail:before {
  content: '\\e908';
}

/** Alcoholmeter */
.icon-alc:before {
  content: '\\e65f';
}

.icon-boerse:before {
  content: '\\e671';
}

.icon-browser:before {
  content: '\\e670';
}

.icon-cal:before {
  content: '\\e669';
}

.icon-cam:before {
  content: '\\e64c';
}

.icon-cinema:before {
  content: '\\e64e';
}

.icon-doc:before {
  content: '\\e667';
}

.icon-download:before {
  content: '\\e65a';
}

.icon-driverlicence:before {
  content: '\\e66b';
}

.icon-dsl:before {
  content: '\\e66e';
}

.icon-game:before {
  content: '\\e630';
}

.icon-heart:before {
  content: '\\e65c';
}

.icon-horoscope:before {
  content: '\\e66d';
}

.icon-immo:before {
  content: '\\e665';
}

.icon-jam:before {
  content: '\\e65d';
}

.icon-job:before {
  content: '\\e663';
}

.icon-lex:before {
  content: '\\e661';
}

.icon-mobile:before {
  content: '\\e64f';
}

.icon-music:before {
  content: '\\e660';
}

.icon-navi:before {
  content: '\\e65e';
}

.icon-webcent:before {
  content: '\\e90b';
}

.icon-hot:before {
  content: '\\e900';
}

.icon-secu:before {
  content: '\\e662';
}

.icon-single:before {
  content: '\\e66a';
}

.icon-soccer:before {
  content: '\\e666';
}

.icon-strom:before {
  content: '\\e66c';
}

.icon-tv:before {
  content: '\\e65b';
}

.icon-weathertool:before {
  content: '\\e664';
}

.icon-zoom:before {
  content: '\\e668';
}

.icon-calender:before {
  content: '\\e60d';
}

.icon-arrow:before {
  content: '\\e616';
}

.icon-schuetze:before {
  content: '\\e61d';
}

.icon-steinbock:before {
  content: '\\e61e';
}

.icon-wassermann:before {
  content: '\\e61f';
}

.icon-fische:before {
  content: '\\e621';
}

.icon-widder:before {
  content: '\\e62a';
}

.icon-stier:before {
  content: '\\e62b';
}

.icon-zwilling:before {
  content: '\\e62c';
}

.icon-krebs:before {
  content: '\\e62d';
}

.icon-loewe:before {
  content: '\\e62e';
}

.icon-jungfrau:before {
  content: '\\e62f';
}

.icon-gender:before {
  content: '\\e633';
}

.icon-waage:before {
  content: '\\e634';
}

.icon-skorpion:before {
  content: '\\e635';
}

.icon-his:before {
  content: '\\e641';
}

.icon-her:before {
  content: '\\e640';
}

.icon-pause:before {
  content: '\\e903';
}

/** Routenplaner */
.icon-change:before {
  content: '\\e60f';
}

.icon-walk:before {
  content: '\\e61a';
}

.icon-bike:before {
  content: '\\e61b';
}

.icon-car:before {
  content: '\\e61c';
}

.icon-check:before {
  content: '\\e63d';
}

.icon-warning:before {
  content: '\\e64a';
}

.icon-info:before {
  content: '\\e672';
}

.icon-lotto:before {
  content: '\\e906';
}

.icon-demail:before {
  content: '\\e907';
}

.icon-plug:before {
  content: '\\e909';
}

.icon-simcard:before {
  content: '\\e90a';
}

.icon-webstory:before {
  content: '\\e912';
}


/** styleguide */
.icon-preview:before {
  content: '\\e629';
}


  @media (min-width: ${tablet}px) {
    .icon {
      font-size: 4rem;
      line-height: 100%;
    }
  }
`;
